/**
 * Política de navegación del Asistente Laboral (Fase depuración UI).
 * Solo rutas visibles en sidebar / hub operativo.
 */
export const LABORAL_SELECTIVE_NAV_PATHS = new Set([
  "/laboral/inicio",
  "/datos-maestros",
  "/registros-patronales-certificados",
  "/catalogo-trabajadores",
  "/control-repse",
  "/confronta-trabajadores-imss",
  "/confronta-emisiones-imss",
]);

/** Rutas legacy Laboral → Trámites; accesibles aunque el módulo activo sea Visor. */
export const LABORAL_LEGACY_REDIRECT_PATHS = new Set([
  "/validador-rfc-sat",
  "/validador-nss-imss",
  "/inscripcion-trabajadores-sat",
  "/inscripcion-trabajadores-imss",
]);

/** Rutas delegadas a Trámites / Panel General — permitidas sin ítem de menú. */
export const LABORAL_DELEGATION_PATHS = new Set([
  "/tramites-fiscales",
  "/datos-maestros",
  "/gestion-datos",
  "/laboral/validar-inscribir",
  ...LABORAL_LEGACY_REDIRECT_PATHS,
]);

export function isLaboralSelectiveNavPath(pathname) {
  const path = String(pathname || "").split("?")[0];
  return LABORAL_SELECTIVE_NAV_PATHS.has(path);
}

export function filterLaboralNavItems(items) {
  return (items || [])
    .filter((item) => LABORAL_SELECTIVE_NAV_PATHS.has(item.to))
    .map((item) => ({ ...item, navSection: undefined, navStep: undefined }));
}

export function filterLaboralHubCards(cards) {
  return (cards || []).filter((card) => LABORAL_SELECTIVE_NAV_PATHS.has(card.path));
}
